export const legalForms = {
    juridicalPerson: 1,
    physicalPerson: 2
};